import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CommonService } from '../common.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
declare let swal: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare var $: any;

@Component({
  selector: 'app-farmsmanagement',
  templateUrl: './farmsmanagement.component.html',
  styleUrls: ['./farmsmanagement.component.css']
})
export class FarmsmanagementComponent implements OnInit {
  samepageroute = "/dashboard/farmsmanagement"
  returnUrl = "/dashboard/addfarmsmanagement";
  viewurl = "/dashboard/viewfarmsmanagement";
  editurl = "/dashboard/editfarmsmanagement";
  backurl = "/dashboard/mastermodule";
  getlistApi: any;
  addUrl: any;
  dataString: any;
  getfarmsListData: any = [];
  table: any;
  loginresponse: any;
  userrole: any;
  isDisabled: boolean = false;
  isLoading = false;
  constructor(private router: Router, private commonService: CommonService) { }
  async ngOnInit() {
    this.isLoading = true;
    var table;
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole = this.loginresponse.read_status;
    //this.farm_userrole=this.loginresponse.user_farm_id;
    if (this.userrole == 1) {
      this.isDisabled = true;
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }

    this.getlistApi = "/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        $(function () {
          table = $("#myTable").DataTable();
        });
        console.log(res.data.id);
        this.getfarmsListData = res.data;
        setTimeout((res) => {
          this.isLoading = false;
        }, 500);
      })
    $('#speciessearch').on('keyup', function () {
      var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
      table.search(inputValue).draw();
    });
  }
  addfarmsmanagement() {
    this.router.navigate([this.returnUrl]);
  }
  viewfarmsmanagement(e) {
    sessionStorage.setItem('farmsId', e.target.id)
    this.router.navigate([this.viewurl]);
  }
  editfarmsmanagement(e) {
    console.log(e.target.id);
    sessionStorage.setItem('farmsId', e.target.id)
    this.router.navigate([this.editurl]);
  }
  backtomastermodule() {
    this.router.navigate([this.backurl]);
  }
  async sweetdelete(e) {
    Swal.fire({
      title: 'Are you sure you want to delete the Farm record ?',
      // text: 'You will not be able to recover this file!',  
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(async (result) => {
      if (result.value) {
        console.log(e.target.id);
        var deleteurl = "/farms/" + e.target.id;
        (await this.commonService.deleteApi(deleteurl)).subscribe(
          res => {
            Swal.fire(
              'Deleted!',
              'The Farm record has been deleted successfully',
              'success'
            );
            let currentUrl = this.samepageroute;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate([currentUrl]);
            });
          })

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'The Farm record has not been deleted',
          'error'
        )
      }
    })
  }

  ///export import part
  async onFileChange(ev) {
    console.log('test');
    console.log(ev);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      this.dataString = jsonData;
      //        let value:any=dataString;
      console.log(this.dataString);
      console.log(this.dataString.data);
      /*$.each(dataString[0], function(key, value){
        console.log(key, value);
        console.log(key);
        console.log(value);
    });*/
      this.addUrl = "/farms";
      (await this.commonService.postApi(this.addUrl, this.dataString.data)).subscribe(
        data => {
          alert(data.message);
        });

      // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");

    }
    reader.readAsBinaryString(file);
  }
  exportfarms() {
    var downloadtabledata = this.getfarmsListData;
    var resultarry = downloadtabledata.map((ele) => {
      return { "Farm name": ele.tnfr_name, "Farm ID": ele.tnfr_code, "Contact person": ele.tnfr_farm_contact_name, "Contact email": ele.tnfr_farm_contact_email, "Contact number": ele.tnfr_farm_contact_number, "Address": ele.tnfr_farm_address }
    })
    console.log(resultarry);
    this.exportAsExcelFile(resultarry, 'farms');
  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }


}


